// extracted by mini-css-extract-plugin
export default {"statusDateText":"walletsWhitelist_statusDateText__M7vp1"};